import { AnchorLink } from "./02_utils/anchorLink";
import { ApiService } from "./02_utils/apiService";
import { Logger } from "./02_utils/logger";
import { Mail } from "./02_utils/mail";
import { Utils } from "./02_utils/utils";
import { Link } from "./03_elements/link/link";
import { Panel } from "./03_elements/panel/panel";
import { Select } from "./03_elements/select/select";
import { Header } from "./04_layout/header/header";
import { Navigation } from "./04_layout/navigation/navigation";
import { Accordion } from "./05_components/accordion/accordion";
import { Form } from "./05_components/form/form";
import { DynamicForm } from "./06_extension/form/dynamicForm";



export class Main {
    constructor() {
      const logger = new Logger();
      const utils = new Utils(logger);
      const apiService = new ApiService(logger);

      // utils
      utils.clickFlyoutPanelBackdrop();

      new Mail();

      new Header(logger, utils);
      new AnchorLink(logger, utils);

      // Navigation
      const navigations: NodeListOf<HTMLElement> = document.querySelectorAll('.js-l-header');
      navigations?.forEach(navigation => {
        new Navigation(navigation, logger, utils);
      });

      new Select(logger, utils);
      new Panel(logger, utils);
      new Form(logger, utils);
      new DynamicForm(logger, utils);
      new Link(logger, utils);
      new Accordion(logger);

    }
}
